import React from 'react'
import Link from 'gatsby-link'
import { CSSTransition } from 'react-transition-group'

import { mobileos } from '../../utils/Browser'
import styles from './Header.module.scss'

class Header extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			headerFixed: false,
			mobileToggle: false,
			headerBlack: null,
			activeSubmenu: false,
			hideApply: false,
			hideBanner: true,
			hideNav: false,
			globalRemoveBanner: true,
		}

		this.stickyHeader = this.stickyHeader.bind(this)
		this.mobileNavToggle = this.mobileNavToggle.bind(this)
	}

	componentDidMount() {
		let stickyHidingTimeout = true
		this.stickyHeader(stickyHidingTimeout)
		this.locationUpdate()
	}

	componentDidUpdate(prevProps, prevState) {
		const pathname = window.location.pathname
		const { location } = this.state
		pathname != location ? this.locationUpdate(prevState) : null
	}

	locationUpdate(prevState) {
		const pathname = window.location.pathname.split('/')
		const disabledPages = ['/academy/apply/', '/academy/apply']
		const links = [
			'careers',
			'success-stories',
			'program-overview',
			'destinations-overview',
			'destinations',
			'destination',
			'updates',
			'fellow-stories',
			'fellows',
			'our-team',
			'academy-faq',
			'fellowship-faq',
			'admissions',
			'author',
			'what-about-college',
			'content',
			'advisory-council',
			'program-overview',
			'apply-now',
			'news',
			'press',
			'financial-aid-tuition',
			'about',
			'interest-form',
			'ambassador',
			'for-educators',
			'parents',
			'family-portal',
			'thank-you-for-your-interest',
			'thank-you',
			'partners-and-supporters',
			'gap-year-resources',
			'2018',
			'parent-interest',
			'gap-year-celebrity-quiz',
			'should-i-take-a-gap-year-quiz',
			'gap-year-personality-quiz',
			'gap-year-bff-quiz',
			'what-type-of-gap-year-quiz',
			'apply-10710',
			'apply',
			'welcome-quiz',
			'formulario',
			'congrats',
			'submitted',
			'apprenticeship-quiz',
			'nominate-a-student',
			'donate',
			'donate-staging',
			'tech-for-good-scholarship',
			'parent-request-info',
			'institute',
			'refer',
			'thank-you-institute-info',
			'thank-you-academy-info',
			'privacy-policy',
			'mentorapplication',
			'redesign-home',
			'academy-stories',
			'/academy/admissions/',
			'/academy/tuition/',
			'/academy/speakers/',
			'/academy/final-clearance-instructions',
			'our-impact-staging',
			'our-impact',
			'tuition-and-aid',
			'/academy/past-speakers/'
		]

		// console.log('THE HOME LOCATION ==== ', this.props.location.pathname, this.props.location);
		// console.log('HOME LOC ', this.props.location.pathname);
		if( this.state.location !== this.props.location.pathname ) {
			if( links.includes(pathname[1]) || this.props.location.pathname === '/' || links.includes(this.props.location.pathname) ) {
				this.setState({
					headerBlack: true,
					location: this.props.location.pathname
				})
			}
			else {
				this.setState({
					headerBlack: false,
					location: this.props.location.pathname
				})
			}
		}

		if( disabledPages.includes(window.location.pathname) ) {
			if( this.state.hideNav === false ) {
				this.setState({
					hideNav: true
				})
			}
		}
		else {
			if( this.state.hideNav === true ) {
				this.setState({
					hideNav: false
				})
			}
		}

		// if (
		// 	links.includes(pathname[1]) ||
		// 	pathname[1] === 'apprenticeship' ||
		// 	pathname[1] == 'author' ||
		// 	pathname[1] == ''
		// ) {
		// 	if( this.state.location !== window.location.pathname ) {
		// 		this.setState({
		// 			headerBlack: true,
		// 			location: window.location.pathname
		// 		})
		// 	}
		// } else {
		// 	// NOTE: If this check removed header gets stuck
		// 	// 		in a performance draining loop trying to
		// 	//		continually reset state.
		// 	if( this.state.headerBlack !== false ) {
		// 		this.setState({ headerBlack: false })
		// 	}
		// }

		if (pathname[1] == 'careers') {
			if( this.state.hideApply !== true ) {
				this.setState({
					hideApply: false
				})
			}
		} else {
			if (this.state.hideApply !== false) {
				this.setState({ hideApply: false })
			}
		}

		if( pathname[1] == 'thank-you-institute-info' || pathname[1] == 'mentorapplication' ) {
			if( this.state.hideBanner === false ) {
				this.setState({ hideBanner: true })
			}
		} else {
			if( this.state.hideBanner === true ){
				this.setState({ hideBanner: false })
			}
		}

		document.body.classList.remove('home')
		document.body.style.marginTop = ''

		if( !this.state.globalRemoveBanner) document.body.classList.remove('banner-top')

		if (pathname[1] == '' || pathname[1] == 'about-us') {
			if( !this.state.globalRemoveBanner) {
				document.body.classList.add('banner-top')
				document.body.style.marginTop = '80px'
				// document.body.style.marginTop = '0px'
			}
		}
		else if (pathname[1] == 'home-staging' || pathname[1] == 'home-staging-2') {
			document.body.style.marginTop = '0'
			document.body.classList.add('home')
		}
		// else if (pathname[2] == 'apply') {
		// 	document.body.style.marginTop = 0
		// }
		// else {
		// 	document.body.style.marginTop = '0px'
		// }


		//console.log(pathname[1], this.state.hideApply)
	}

	stickyHeader(stickyHidingTimeout) {
		const trigger = 65,
			header = document.querySelector('#header')

		window.addEventListener('scroll', () => {
			let doc = document.documentElement,
				top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)

			if (top > trigger) {
				this.setState(
					{
						headerFixed: true
					},
					() => {
						stickyHidingTimeout = false
					}
				)
			} else {
				if (this.state.mobileToggle === false) {
					this.setState(
						{
							headerFixed: false
						},
						() => {
							stickyHidingTimeout = true
						}
					)
				}
			}
		})
	}

	mobileNavToggle() {
		const trigger = 65,
			header = document.querySelector('#header'),
			top =
				(window.pageYOffset || document.documentElement.scrollTop) -
				(document.documentElement.clientTop || 0)

		if (this.state.mobileToggle === false) {
			this.setState({
				mobileToggle: true,
				headerFixed: true
			})
		} else {
			if (top > trigger) {
				this.setState({
					mobileToggle: false,
					headerFixed: true
				})
			} else {
				this.setState({
					mobileToggle: false,
					headerFixed: false
				})
			}
		}
	}

	handleMouseEnter(index, e) {
		this.setState({
			activeSubmenu: index,
			headerFixed: true
		})
	}
	handleMouseLeave() {
		this.setState({
			activeSubmenu: false
		})
	}
	handleNavClick(e) {
		e.stopPropagation()
		if( mobileos ) {
			this.setState({
				activeSubmenu: false,
				mobileToggle: false
			}, () => this.forceUpdate())
		}
		else {
			this.handleMouseLeave()
		}
	}

	render() {
		return (
			<div
				className={`${styles.Header} ${this.state.headerFixed &&
					styles.Header__Fixed} ${this.state.headerBlack &&
					styles.Header__Black} ${this.state.headerFixed && ' fixed'} ${this.state.hideNav && styles.Header__Hidden} ${this.props.location.pathname.split('/')[1]}-header`}
				id="header"
			>
				<Link to="/" className={`${styles.Logo}`}>
				{
					(this.state.headerBlack && this.props.location.pathname != '/') && !this.state.headerFixed &&
					<img src="/images/redesign/global-citizen-year-new-logo.svg" alt="Global Citizen Year Logo" />
				}
				{
					(!this.state.headerBlack || this.props.location.pathname == '/') && !this.state.headerFixed &&
					<img src="/images/redesign/global-citizen-year-new-logo-white.svg" alt=""/>
				}
				{
					this.state.headerFixed &&
					<img src="/images/redesign/global-citizen-year-new-logo.svg" alt="Global Citizen Year Logo" />
				}
				</Link>
				{
					this.state.activeSubmenu !== false && mobileos &&
					<div className="flex back-to-main" onClick={ (e) => this.handleMouseLeave(2, e) }>
						<p className="h3">Back</p>
					</div>
				}
				{!this.state.hideApply && !this.state.mobileToggle && (
					<div
						className={`${styles.Hide__Desktop} ${styles.Nav__Item} ${
							styles.ApplyButton__Wrapper
						}`}
					>
						<Link
							to="/#signup"
							className={`${styles.ApplyButton} button button--small`}
							onClick={(e) => this.handleNavClick(e)}
							target="_blank"
						>
							Request Info
						</Link>
					</div>
				)}
				<div
					className={`${styles.MobileToggle} ${mobileos &&
						styles.mobileDisplay}`}
					onClick={() => this.mobileNavToggle()}
					style={this.state.mobileToggle ? { backgroundColor: '#F9F9F8' } : {}}
				>
					{this.state.mobileToggle ? (
						<img src="/images/icon-close.svg" alt="menu icon" />
					) : (
						<img src="/images/icon-menu.svg" alt="close icon" />
					)}
				</div>
				<div
					className={`${styles.Nav} ${this.state.mobileToggle &&
						styles.Open} ${mobileos && styles.Nav__mobile}`}
				>
					<div
						className={styles.Nav__Item}
						onClick={ (e) => {
							if( mobileos) { this.handleMouseEnter(2, e) }
						}}
						onMouseEnter={e => {
							this.handleMouseEnter(2, e)
						}}
						onMouseLeave={e => {
							this.handleMouseLeave(2, e)
						}}
					>
						<Link
							to="/academy/"
							onClick={(e) => mobileos ? e.preventDefault() : this.handleNavClick(e)}
						>
							Programs
						</Link>
						{(this.state.activeSubmenu == 2) && (
							<ul
								className={`sub-menu ${styles.submenu} ${this.state
									.headerBlack && styles.Header__Black} ${mobileos &&
									styles.submenu__mobile} mega-menu`}
							>
								<li>
									<div className="flex">
										<h3 className="h3 headline-with-accent green">The Academy</h3>
										<Link to="/academy/" className="hoverlink" onClick={(e) => this.handleNavClick(e)}>Learn More</Link>
									</div>
									<p className="excerpt">An intensive, 12-week leadership experience that equips students worldwide with powerful skills for a lifetime of social impact. Designed as a 7-10 hour per week commitment, the Academy adds an enriching layer of purpose to high school, college, travel, or work.</p>
									<div className="link-container">
										<div className="item">
											<Link to="/experience/academy-experience/" onClick={(e) => this.handleNavClick(e)}><img src="https://images.ctfassets.net/j91b9gwu8s3q/5w9g7mPCqgWYKtrEEbedq0/f122f3d796ec269f696fbf3cdce2a854/academy-experience.jpg" alt=""/></Link>
											<p className="title"><Link to="/experience/academy-experience/" onClick={(e) => this.handleNavClick(e)}>The Experience</Link></p>
										</div>
										<div className="item">
											<Link to="/academy/speakers/" onClick={(e) => this.handleNavClick(e)}><img src="https://images.ctfassets.net/j91b9gwu8s3q/5FaE7EsGlL8JjEXfplAQuX/9ede9f07b8cfcdf7c45f64d719bbc381/The_Speakers.png" alt=""/></Link>
											<p className="title"><Link to="/academy/speakers/" onClick={(e) => this.handleNavClick(e)}>The Speakers</Link></p>
										</div>
										<div className="item">
											<Link to="/academy-stories/" onClick={(e) => this.handleNavClick(e)}><img src="https://images.ctfassets.net/j91b9gwu8s3q/1A4IIARwAZjhYdKTAXPcqc/c31ab9b66e64cca9f3daa9850a2d06e4/Academy_Stories.jpg" alt=""/></Link>
											<p className="title"><Link to="/academy-stories/" onClick={(e) => this.handleNavClick(e)}>Academy Stories</Link></p>
										</div>
										<div className="item">
											<Link to="/academy-faq/" onClick={(e) => this.handleNavClick(e)}><img src="https://images.ctfassets.net/j91b9gwu8s3q/2Tl6kBhXjQ05kKLDfYwZtd/7ff2c0d12da0c31b18e278d8e6e5416d/Academy_FAQs.jpg" alt=""/></Link>
											<p className="title"><Link to="/academy-faq/" onClick={(e) => this.handleNavClick(e)}>FAQs</Link></p>
										</div>
									</div>
								</li>
								<li>
									<div className="flex">
										<h3 className="h3 headline-with-accent blue">The Fellowship</h3>
										<Link
											to="/fellowship/"
											className="hoverlink"
											onClick={(e) => mobileos ? this.mobileNavToggle() : this.handleNavClick(e)}>
												Learn More
											</Link>
									</div>
									<p className="excerpt">A deep, 8-month immersion where students live alongside the global majority in Brazil, Ecuador or India and develop the insights, skills, and network to become the leaders our world needs. Fellows build language fluency, develop resilience, and become part of a community a world away from home.</p>
									<div className="link-container">
										<div className="item">
											<Link to="/experience/fellowship-experience/" onClick={(e) => this.handleNavClick(e)}><img src="https://images.ctfassets.net/j91b9gwu8s3q/3ZLa7eOphapeDbxDCA7lXP/84640656fbcc91829a5350fadac26baf/fellowship-experience.jpg" alt=""/></Link>
											<p className="title"><Link to="/experience/fellowship-experience/" onClick={(e) => this.handleNavClick(e)}>The Experience</Link></p>
										</div>
										<div className="item">
											<Link to="/destinations-overview/" onClick={(e) => this.handleNavClick(e)}><img src="https://images.ctfassets.net/j91b9gwu8s3q/1CmKtDHRwbB7DbxwsrFrvG/be986a08ad70cedd262be08095a75e76/fellowship-destination.jpg" alt=""/></Link>
											<p className="title"><Link to="/destinations-overview/" onClick={(e) => this.handleNavClick(e)}>Destinations</Link></p>
										</div>
										<div className="item">
											<Link to="/fellow-stories/" onClick={(e) => this.handleNavClick(e)}><img src="https://images.ctfassets.net/j91b9gwu8s3q/jBjZyu2QV2wtUtv4bXVnJ/e8274d0979707deec42eaa414b69b78c/Fellowship_Stories.jpg" alt=""/></Link>
											<p className="title"><Link to="/fellow-stories/" onClick={(e) => this.handleNavClick(e)}>Fellowship Stories</Link></p>
										</div>
										<div className="item">
											<Link to="/fellowship-faq/" onClick={(e) => this.handleNavClick(e)}><img src="https://images.ctfassets.net/j91b9gwu8s3q/7xbGbNViJecHKdR8kRox6i/aa29c9c77fb6f9675c1b3bbf8b6da005/Fellowship_FAQs.jpg" alt=""/></Link>
											<p className="title"><Link to="/fellowship-faq/" onClick={(e) => this.handleNavClick(e)}>FAQs</Link></p>
										</div>
									</div>
								</li>
								<li className="banner"><p>Not sure which program is right for you? <a href="https://globalcitizenyear.typeform.com/to/qrmrqkgz/" onClick={(e) => this.handleNavClick(e)} target="_blank">Take the Quiz</a></p></li>
							</ul>
						)}
					</div>
					<div
						className={styles.Nav__Item}
						onClick={ (e) => {
							if( mobileos) { this.handleMouseEnter(4, e) }
						}}
						onMouseEnter={e => {
							this.handleMouseEnter(4, e)
						}}
						onMouseLeave={e => {
							this.handleMouseLeave(4, e)
						}}
					>
						<Link
							to="/admissions/"
							onClick={(e) => mobileos ? e.preventDefault() : this.handleNavClick(e)}
						>
							Admissions
						</Link>
						{(this.state.activeSubmenu == 4) && (
							<ul
								className={`${styles.submenu} ${this.state.headerBlack &&
									styles.Header__Black} ${mobileos && styles.submenu__mobile}`}
							>
								<li>
									<Link
										to="/admissions/"
										onClick={(e) => this.handleNavClick(e)}
									>
										Admissions & Tuition
									</Link>
								</li>
								<li>
									<Link
										to="/financial-aid-tuition/"
										onClick={(e) => this.handleNavClick(e)}
									>
										Scholarships
									</Link>
								</li>
								<li>
									<Link
										to="/what-about-college/"
										onClick={(e) => this.handleNavClick(e)}
									>
										What About College?
									</Link>
								</li>
								<li>
									<Link
										to="/#signup"
										onClick={(e) => this.handleNavClick(e)}
									>
										Request Info
									</Link>
								</li>
							</ul>
						)}
					</div>
					<div
						className={styles.Nav__Item}
						onClick={ (e) => {
							if( mobileos) {
								this.handleMouseEnter(5, e)
								e.stopPropagation()
							}
						}}
						onMouseEnter={e => {
							this.handleMouseEnter(5, e)
						}}
						onMouseLeave={e => {
							this.handleMouseLeave(5, e)
						}}
					>
						<Link
							to="/about-us/"
							onClick={(e) => mobileos ? e.preventDefault() : this.handleNavClick(e)}
						>
							About Us
						</Link>
						{(this.state.activeSubmenu == 5) && (
							<ul
								className={`${styles.submenu} ${this.state.headerBlack &&
									styles.Header__Black} ${mobileos && styles.submenu__mobile}`}
							>
								<li>
									<Link to="/donate/">Donate</Link>
								</li>
								<li>
									<Link to="/about-us/" onClick={(e) => this.handleNavClick(e)}>
										Our Story
									</Link>
								</li>
								<li>
									<Link to="/our-impact/" onClick={(e) => this.handleNavClick(e)}>
										Our Impact
									</Link>
								</li>
								<li>
									<Link to="/our-team/" onClick={(e) => this.handleNavClick(e)}>
										Our Team
									</Link>
								</li>
								<li>
									<Link to="/press/" onClick={(e) => this.handleNavClick()}>
										News & Press
									</Link>
								</li>
								<li>
									<Link to="/success-stories/" onClick={(e) => this.handleNavClick(e)}>
										Alumni Stories
									</Link>
								</li>
								<li>
									<Link to="/parents/" onClick={(e) => this.handleNavClick(e)}>
										For Parents
									</Link>
								</li>
								<li>
									<Link to="/for-educators/" onClick={(e) => this.handleNavClick(e)}>
										For Educators
									</Link>
								</li>
							</ul>
						)}
					</div>
					{
						!this.state.hideApply &&
						<div
							className={`${styles.Nav__Item} ${styles.ApplyButton__Wrapper}`}
						>
							<Link
								to="/#signup"
								className={`${styles.ApplyButton} button button--small`}
								onClick={(e) => this.handleNavClick(e)}
								target="_blank"
							>
								Request Info
							</Link>
						</div>
					}
					{
						!this.state.globalRemoveBanner &&
						!this.state.hideBanner &&
						<div id="green-banner" className="flex">
							<div className="left-block">
								<h3 className="text-right">REGISTER TO VOTE</h3>
								<p className="text-right">Take 2 minutes to register to vote at your current address.</p>
							</div>
							<div className="right-block">
								<a href="https://www.whenweallvote.org/globalcitizenyear/" target="_blank"
								className="button button-small">REGISTER NOW</a>
							</div>
							<div className="strokes" style={{ background: `url(/images/white-brushstrokes.png) center no-repeat`, backgroundSize: 'contain' }}></div>
						</div>
						/*<div id="green-banner" className="shawn-mendes-banner" style={{ backgroundImage: 'url(/images/HR2B.jpg)' }}>
							<div className="banner-content-wrap flex">
								<div className="left-block">
									<h3>We're thrilled to partner with the Shawn Mendes Foundation to launch Global Citizen Academy!</h3>
									<Link to="/academy/"
									className="button">EXPLORE THE ACADEMY</Link>
								</div>
								<div className="right-block">
									<img src="/images/GCA_X_SMF_blue.png" alt="Shawn Mendes Foundation logo" />
								</div>
							</div>
						</div>*/
					}
				</div>
				{
					!this.state.globalRemoveBanner &&
					!this.state.hideBanner &&
					<div id="green-banner-mobile">
						<h3>REGISTER TO VOTE</h3>
						<p>Take 2 minutes to register to vote at<br/>
						your current address.</p>
						<p><a href="https://www.whenweallvote.org/globalcitizenyear/" target="_blank"
						className="button button-small">REGISTER NOW</a></p>
						<div className="strokes" style={{ background: `url(/images/white-brushstrokes.png) center no-repeat`, backgroundSize: 'contain' }}></div>
					</div>
					/*<div id="green-banner-mobile" className="shawn-mendes-banner" style={{ backgroundImage: 'url(/images/HR2b.jpg)' }}>
						<div className="banner-content-wrap flex">
							<div className="left-block">
								<h3>We're thrilled to partner with the Shawn Mendes Foundation to launch Global Citizen Academy!</h3>
								<Link to="/academy/"
								className="button">EXPLORE THE ACADEMY</Link>
							</div>
							<div className="right-block">
								<img src="/images/GCA_X_SMF_blue.png" alt="Shawn Mendes Foundation logo" />
							</div>
						</div>
					</div>*/
				}
			</div>
		)
	}
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js